"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveDocumentSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.moveDocumentSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['blobUri', 'fileExtension', 'fileName', 'userID'],
    properties: {
        acl: {
            type: ['array', 'null'],
            items: {
                type: 'string',
                errorMessage: 'should be a string',
            },
            errorMessage: 'should be an array of strings or null',
        },
        blobUri: {
            type: 'string',
            errorMessage: 'should be a string',
        },
        claimID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        fileExtension: {
            type: 'string',
            errorMessage: 'should be a string',
        },
        fileName: {
            type: 'string',
            errorMessage: 'should be a string',
        },
        generateClaimCoverLetter: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be a boolean or null',
        },
        documentCreatedID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        metadata: {},
        reportingPeriodID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        reportType: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.ReportType), [null]),
            errorMessage: 'Should equate to a valid ReportType Enum value or null',
        },
        requestLetterID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        userID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
    },
};
